import { Link } from 'react-router';
import { K } from '../kabinet/atoms';
import { IconChevron } from '../ui/icons';

/**
 * ═══════════════════════════════════════════════════════════════════════
 * «НАЗАД» НАД ВТОРОСТЕПЕННЫМ ЭКРАНОМ.
 *
 * В эталоне она стоит на девяти экранах из пятнадцати: запросы,
 * правила, намерения, кабинеты, подключение, пароль, сборка,
 * поддержка, счета и оплаты. Сверка 26.08 сообщала «кнопка-назад:
 * НЕТ В ПРОДУКТЕ» восемь раз подряд — по разу на экран.
 *
 * ═══════════════════════════════════════════════════════════════════════
 * КУДА ОНА ВЕДЁТ — РЕШЕНО НАМИ, А НЕ ВЗЯТО ИЗ ЭТАЛОНА
 *
 * В эталоне подписи такие: на «Поддержке» — «Назад в счета и оплаты»,
 * на «Сборке» — «Назад в пароль и доступ». Это не замысел, а СЛЕД
 * СТЕНДА: он подставляет предыдущий экран из своего списка. Никакой
 * человек не приходит в поддержку из счетов чаще, чем откуда угодно
 * ещё.
 *
 * Поэтому подпись у нас одна — «Назад в биддер», и ведёт она на
 * главный экран кабинета. Два довода:
 *
 *   ▸ так делает и сам эталон там, где подпись осмысленна:
 *     на экранах проверки ключа стоит именно «Назад в биддер»;
 *
 *   ▸ `history.back()` был бы честнее по букве, но врёт по сути:
 *     на второй-третьей странице подряд он уводит туда, откуда
 *     человек уже ушёл, а после перезагрузки — вообще из кабинета.
 *
 * Где родитель ОЧЕВИДЕН, он и указывается: у экрана запросов это
 * кампания, у подключения — кабинеты. Так и в эталоне.
 *
 * Вопрос дизайнеру записан: подписи стенда закрепляем или нет.
 * ═══════════════════════════════════════════════════════════════════════
 */
export function Назад({ to, куда }: { to: string; куда: string }) {
  return (
    <Link
      to={to}
      data-d="кнопка-назад"
      className={`${K.кнопкаНазад} no-underline`}
      title={`Вернуться: ${куда}`}
    >
      {/* Стрелка — тот же значок, что у выпадений, повёрнутый
          на 90°: в эталоне это одна и та же галочка, а не второй
          контур. Один контур на две роли не разъедется. */}
      <IconChevron size={14} dir="left" />
      Назад в {куда}
    </Link>
  );
}
